import { render, staticRenderFns } from "./access-point-form.vue?vue&type=template&id=d594f308&scoped=true&"
import script from "./access-point-form.vue?vue&type=script&lang=ts&"
export * from "./access-point-form.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d594f308",
  null
  
)

export default component.exports